/* eslint-disable @next/next/no-img-element */
import PropTypes from "prop-types"
import dynamic from "next/dynamic"
const MediaVideo = dynamic(() => import("./MediaVideo"))
import Image from "next/image"

const MediaItem = ({ assets, height }) => {
  return (
    <div className="mx-auto max-w-screen-lg flex justify-center w-full h-full">
      {assets?.map(({ fields, sys }, id) => {
        const isPressReleseaseArticle = fields?.internalTitle.includes(
          "Press Room Article Page"
        )
        const {
          altText = "",
          imageUrl = "//fastly.picsum.photos/id/991/200/300.jpg?hmac=BdTxfK2wHhsGppraQzb5puxPKb5mPVzDaZPz8IiC44Q",
          // details: { image: { width = 100, height = 100 } = {} } = {},
        } = fields ?? {}
        return (
          <div
            key={sys?.id || id}
            className={`w-full h-full flex overflow-hidden ${
              isPressReleseaseArticle
                ? "justify-start p-[32px]"
                : "justify-center"
            }`}
          >
            {fields?.type === "Image" && (
              <img
                src={imageUrl}
                key={sys?.id}
                alt={altText}
                title={altText}
                className="block w-full h-full"
                // width={width}
                // height={height}
                loading="lazy"
              />
            )}
            {fields?.type === "Video" && (
              <MediaVideo fields={fields} height={height} />
            )}
          </div>
        )
      })}
    </div>
  )
}

MediaItem.propTypes = {
  assets: PropTypes.array,
  height: PropTypes.string,
}

export default MediaItem
